import { ReactNode } from "react";
import { UserRole } from "dora-contracts";
import { useSelector } from "../redux-store";
import { selectUser } from "../ducks/auth/selectors";
import { useFeature } from "../hooks";

const VisibleToRoles = ({
  roles,
  children,
}: {
  roles: UserRole[];
  children: ReactNode;
}) => {
  const rolesFeatureEnabled = useFeature("users-roles");
  const user = useSelector(selectUser);
  if (
    rolesFeatureEnabled &&
    (!user || !user.role || !roles.includes(user.role))
  ) {
    return null;
  }
  return <>{children}</>;
};

export default VisibleToRoles;
